import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import './SelectLocale.css';

const localeOptions = [
  {
    text: 'Čeština',
    value: 'cs'
  },
  {
    text: 'Deutsch',
    value: 'de'
  },
  {
    text: 'English',
    value: 'en'
  },
  {
    text: 'Español',
    value: 'es'
  },
  {
    text: 'Français',
    value: 'fr'
  },
  {
    text: 'Italiano',
    value: 'it'
  },
  {
    text: 'Nederlands',
    value: 'nl'
  },
  {
    text: 'Norsk',
    value: 'no'
  },
  {
    text: 'Polski',
    value: 'pl'
  },
  {
    text: 'Português-Brasil',
    value: 'pt'
  },
  {
    text: 'Suomi',
    value: 'fi'
  },
  {
    text: 'Svenska',
    value: 'sv'
  },
  {
    text: '简体中文',
    value: 'zh'
  },
  {
    text: '日本語',
    value: 'ja'
  },
  {
    text: '한국어',
    value: 'ko'
  }
];

const messages = defineMessages({
  title: {
    id: 'title',
    defaultMessage: 'Lifesize Share'
  }
});

class SelectLocale extends Component {
  componentDidMount() {
    document.title = this.props.intl.formatMessage(messages.title);
  }

  render() {
    const twoCharLocale = this.props.intl.locale.slice(0, 2);

    return (
      <Dropdown
        defaultValue={twoCharLocale}
        fluid
        selection
        options={localeOptions}
        className="dropdownClass"
        onChange={(event, data) => {
          this.props.changeLocale(data.value);
        }}
      />
    );
  }
}

SelectLocale.propTypes = {
  changeLocale: PT.func,
  intl: PT.object
};

export default injectIntl(SelectLocale);



// WEBPACK FOOTER //
// ./src/components/SelectLocale/SelectLocale.js